import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import comdetailsdata from '../data/comdetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import helper from '../factory/Helper';
 

const MFinancialPreview = (props) => {
  const {response} = props

  return (
    <div>
    <Field component={CusFormLabel} 
      leftLabelId={'lblLastestYrEndDate'} leftLabelName={comdetailsdata.label.latestFinancialYrEndDate}
      id={'LatestYrEndDate'} name={response.LatestFinancialYearEndDate !==null? helper.formatDateDDMMYYYY(response.LatestFinancialYearEndDate):''} />
              
    <Field component={CusFormLabel} 
      leftLabelId={'lblAnnRev1'} leftLabelName={comdetailsdata.label.annualRevenue}
      id={'AnnualRevenue1'} name={response.AnnualRevenue1 !==null || response.AnnualRevenue1 !=='0.00' ? ('SGD '+helper.formatAmount(response.AnnualRevenue1)):''} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblProfitLoss'} leftLabelName={comdetailsdata.label.profitLossBeforeTax}
      id={'PrfitLoss1'} name={response.ProfitOrLossBeforeTax1 !==null ||response.ProfitOrLossBeforeTax1 !=='0.00' ? ('SGD '+helper.formatAmount(response.ProfitOrLossBeforeTax1)):''} />

    {(response.PreviousFinancialYearEndDate !== null) &&
    <div>
    <Field component={CusFormLabel} 
      leftLabelId={'lblPrevYrEndDate'} leftLabelName={comdetailsdata.label.prevFinancialYrEndDate}
      id={'PrevYrEndDate'} name={response.PreviousFinancialYearEndDate !==null? helper.formatDateDDMMYYYY(response.PreviousFinancialYearEndDate):''} />
              
    <Field component={CusFormLabel} 
      leftLabelId={'lblAnnRev2'} leftLabelName={comdetailsdata.label.annualRevenue}
      id={'AnnualRevenue2'} name={response.AnnualRevenue2 !==null || response.AnnualRevenue2 !=='0.00' ? ('SGD '+helper.formatAmount(response.AnnualRevenue2)):''} />

    <Field component={CusFormLabel} 
      leftLabelId={'lblProfitLoss2'} leftLabelName={comdetailsdata.label.profitLossBeforeTax}
      id={'PrfitLoss2'} name={response.ProfitOrLossBeforeTax2 !==null ||response.ProfitOrLossBeforeTax2 !=='0.00' ? ('SGD '+helper.formatAmount(response.ProfitOrLossBeforeTax2)):''} />
    </div>}
    </div>
    
  )
}


export default MFinancialPreview;